package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Tab
import androidx.compose.material3.TabRow
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.form.AppController

/**
 * Hub unificado: Parte 1 = Relatório Fotográfico-Alojamento;
 * Parte 2 = Checklist Alojamento. Salvar exige ambas as partes.
 */
@Composable
fun SharedRelatorioAlojamentoScreen(controller: AppController) {
    var parte by remember { mutableStateOf(0) }

    Column(modifier = Modifier.fillMaxSize()) {
        Text(
            text = "realizar parte 1 e 2",
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Medium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp, vertical = 8.dp)
        )
        TabRow(selectedTabIndex = parte) {
            Tab(
                selected = parte == 0,
                onClick = { parte = 0 },
                text = { Text("Parte 1 — Fotográfico") }
            )
            Tab(
                selected = parte == 1,
                onClick = {
                    controller.syncCamposCompartilhadosAlojamento()
                    parte = 1
                },
                text = { Text("Parte 2 — Checklist") }
            )
        }
        when (parte) {
            0 -> SharedRelatorioFotoScreen(
                controller = controller,
                modoCombinado = true,
                onAvancarParte2 = {
                    controller.syncCamposCompartilhadosAlojamento()
                    parte = 1
                }
            )
            else -> SharedChecklistAlojamentoScreen(
                controller = controller,
                modoCombinado = true
            )
        }
    }
}
